// extracted by mini-css-extract-plugin
export default {"container":"a0-z","heading":"b0-z","links":"c0-z","copy":"d0-z","subCopy":"e0-z","linksLeft":"f0-z","linksCenter":"g0-z","linksRight":"h0-z","link":"i0-z","onlyLink":"j0-z"};